import api from "../index";

// Types
interface BillingQueryParams {
  page?: number;
  limit?: number;
  status?: string;
}

// Get billing overview (subscription, payment methods, last invoice, metrics)
export const getBillingOverview = async () => {
  return await api.get("/billing/overview");
};

// Get all invoices (paginated)
export const getInvoices = async (params?: BillingQueryParams) => {
  const queryParams = new URLSearchParams();
  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        queryParams.append(key, String(value));
      }
    });
  }
  const queryString = queryParams.toString();
  return await api.get(`/billing/invoices${queryString ? `?${queryString}` : ""}`);
};

// Get single invoice by ID
export const getInvoiceById = async (invoiceId: string) => {
  return await api.get(`/billing/invoices/${invoiceId}`);
};

// Get invoice PDF URL
export const getInvoicePdfUrl = (invoiceId: string) => {
  return `${process.env.REACT_APP_BACKEND_API}/billing/invoices/${invoiceId}/pdf`;
};

// Get payment history (paginated)
export const getPaymentHistory = async (params?: BillingQueryParams) => {
  const queryParams = new URLSearchParams();
  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        queryParams.append(key, String(value));
      }
    });
  }
  const queryString = queryParams.toString();
  return await api.get(`/billing/payments${queryString ? `?${queryString}` : ""}`);
};

// Get saved payment methods
export const getPaymentMethods = async () => {
  return await api.get("/billing/payment-methods");
};

// Get subscription history
export const getSubscriptionHistory = async () => {
  return await api.get("/billing/subscription-history");
};

// Sync billing data from Stripe (backfill invoices, payments, payment methods)
export const syncBillingData = async () => {
  return await api.post("/billing/sync");
};
